import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchDeliverable, fetchDeliverableDraft } from "./api"

export function useDeliverable(id: string) {
  const getContext = useApiContext()
  return useQuery({
    queryKey: ["deliverable", id],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchDeliverable(context, id)
    },
  })
}

export function useDeliverableDraft(id: string) {
  const getContext = useApiContext()
  return useQuery({
    queryKey: ["deliverableDraft", id],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchDeliverableDraft(context, id)
    },
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
  })
}
